module.exports = __webpack_public_path__ + "img/11.573b9038.png";